import * as types from './mutations-types'

export const updateConversationFooterHeight = ({ commit }, height) => {
  commit(types.UPDATE_CONVERSATION_FOOTER_HEIGHT, height)
}

export const updateHeaderHeight = ({ commit }, height) => {
  commit(types.UPDATE_HEADER_HEIGHT, height)
}

export const setOverlayOpen = ({ commit }, open) => {
  commit(types.SET_OVERLAY_OPEN, open)
}

export const setParentSize = ({ commit }, size) => {
  commit(types.SET_PARENT_SIZE, size)
}
